import { I18n } from 'react-redux-i18n';

export const assessmentTypeOptions = [
  { name: I18n.t('Assessment'), value: 'test' },
  { name: I18n.t('Battery'), value: 'battery' },
  { name: I18n.t('Solution'), value: 'solution' },
];
